/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import React, { Component } from 'react';
import AlertMessage from './Alert';

class About extends Component {
    render() {
        return (
            <div id="main"
                className="grid md:grid-flow-col-dense sm:grid-flow-row-dense grid-cols-6 gap-4 my-4">

                <section className="col-start-2 col-span-4">
                    <AlertMessage />
                    <div id="about" className="pt-8 lg:pt-16 px-4 mx-auto text-gray-900 dark:text-white">
                        <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center">About InDeep<sup>Net</sup></h2>
                        <div className="mb-4 text-justify">
                            <p>
                                InDeep is a powerful tool that enables the prediction of functional binding sites within proteins, including those involved in protein-protein interactions (PPIs). PPIs play essential roles in biological pathways and have gained attention as potential targets for drug discovery. However, designing drugs that effectively target PPIs is challenging due to their unique characteristics.
                            </p>
                            <p>
                                InDeep addresses this challenge by utilizing deep learning techniques and a curated dataset of PPIs. It outperforms existing methods in predicting ligandable binding sites for both PPI targets and conventional targets. By analyzing experimental structures or molecular dynamics trajectories, InDeep provides valuable insights into relevant binding pockets at or near PPI interfaces.
                            </p>
                            <p>
                                InDeep leverages deep learning techniques and a curated dataset of PPIs to predict functional binding sites. It can analyze experimental structures or molecular dynamics trajectories to enhance its predictions. The benchmark of InDeep demonstrates its superiority over state-of-the-art ligandable binding site predictors for assessing both PPI targets and conventional targets.
                            </p>
                            <p>
                                InDeep<sup>net</sup>, a user-friendly website, serves as an interface for accessing and utilizing InDeep's functionalities. It offers a comprehensive set of tools, including the prediction of ligandable binding sites, profiling of epitope binding sites, and tracking of druggability and interactability scores along molecular dynamics trajectories.
                            </p>
                            <p>
                                With InDeep and InDeep<sup>net</sup>, researchers and drug designers have a valuable toolbox at their disposal for iPPI drug design. These tools enhance the understanding of PPIs as therapeutic targets, aid in the design of drugs targeting PPIs, and facilitate the exploration of epitope binding mechanisms.
                            </p>
                            <p>
                                To learn more about InDeep, see the article about <a className="text-blue-600 hover:text-blue-400" href="https://academic.oup.com/bioinformatics/article/38/5/1261/6462189">InDeep</a>.
                            </p>
                        </div>
                    </div>
                    <div id="policy" className="pt-2 lg:pt-4 pb-8 lg:pb-16 px-4 mx-auto text-gray-900 dark:text-white">
                        <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center">Data Usage Policy</h2>
                        <div className="mb-4 text-justify">
                            <p>
                                At InDeep<sup>Net</sup>, we are committed to respecting your privacy and ensuring transparency regarding the use of your data. We do not store any personal information apart from what is strictly necessary for the functionality of the platform.
                            </p>
                            <p>
                                Cookies are only used for functional purposes to enhance your experience on the website. They are not used for tracking or advertising and do not collect any personal information about you.
                            </p>
                            <p>
                                The only personal data we may store is your email address, and only if you choose to provide it. This is solely for the purpose of sending you notifications regarding the results of your InDeep calculations. The email address will be stored securely and retained for a maximum of 30 days before being permanently deleted.
                            </p>
                            <p>
                                By using InDeep<sup>Net</sup>, you agree to this data usage policy. If you have any questions or concerns about how your data is handled, please do not hesitate to contact us.
                            </p>
                        </div>
                    </div>
                </section >
            </div>
        );
    }
}

export default About;